// local
// actions
import { pending, rejected, fulfilled } from '../async';
import { showSnackbar } from 'app/redux/actions/snackbar';
import dispatchError from '../error';
// api
import * as Delivery from 'app/api/delivery';

const ACTION_KEY = 'REQUEST_DELIVERY';

export function updateCylinderQtd(supplierId, patientId, pendingCylinderQtdEdit, diff) {
    return {
        type: `${ACTION_KEY}_UPDATE_QTD`,
        payload: { supplierId, patientId, pendingCylinderQtdEdit, diff },
    };
}

export function listPendingDelivery() {
    return dispatch => {
        dispatch(pending(ACTION_KEY));
        Delivery.listPendingDelivery()
            .then(payload => dispatch(fulfilled(ACTION_KEY, payload)))
            .catch(err => {
                dispatch(rejected(ACTION_KEY, err));
                dispatchError(dispatch, err);
            });
    };
}

export function savePendingDelivery(data) {
    return dispatch => {
        dispatch(pending(ACTION_KEY));
        Delivery.savePendingDelivery(data)
            .then(() => {
                dispatch(listPendingDelivery());
                dispatch(showSnackbar({ title: 'Solicitação realizada com sucesso!', action: true }));
            })
            .catch(err => {
                dispatch(rejected(ACTION_KEY, err));
                dispatchError(dispatch, err);
            });
    };
}

export function resetPendingDelivery() {
    return {
        type: `${ACTION_KEY}_RESET`,
    };
}
